var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head-page"},[_c('Header',{attrs:{"title":_vm.$t('staking.title'),"icontype":2,"iconkey":'todo-list-o',"iconurl":'staking-list'}}),_c('div',{staticClass:"head-page-overflow"},_vm._l((_vm.data),function(data,index){return _c('StakingItem',{key:index,attrs:{"item":data}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }